import { doLogin } from '../../apis/loginApi';
import { makeMenuTree } from '../../services/UtilService';

class LoginController {
  constructor(
    { store, updateStore, resetTimer },
    modalService,
    validateService,
    navigate,
    { valueObj, setValueObj },
    { loginMsgDp, setLoginMsgDp }
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
    this.valueObj = valueObj;
    this.setValueObj = setValueObj;
    this.loginMsgDp = loginMsgDp;
    this.setLoginMsgDp = setLoginMsgDp;

    this.resetTimer = resetTimer;
  }

  // 조회
  async fnLogin() {
    this.setLoginMsgDp('');
    let response;

    try {
      response = await doLogin(this.valueObj);

      if (response instanceof Error) {
        this.setLoginMsgDp(true);
      } else {
        if (response.logined !== undefined && response.logined !== null) {
          if (response.logined === true) {
            sessionStorage.setItem('token', response.token);

            this.updateStore('logined', true);
            this.updateStore('userType', response.userType);
            this.updateStore('entSn', response.entSn);
            this.updateStore('userSn', response.userSn);
            this.updateStore('userId', response.userId);
            this.updateStore('userNm', response.userNm);
            this.updateStore('authrtId', response.authrtId);
            this.updateStore('menuList', makeMenuTree(response.menuList));

            this.resetTimer(true);

            if (response.tmprPswdYn === 'Y') {
              const move = () => {
                this.navigate('/member/userInfo/chgPassword');
              };
              this.modalService.errorAlert(
                '임시비밀번호를 변경해주세요.',
                move
              );
            }
            this.navigate('/');
          } else {
            if (response.errCode === '0010') {
              this.setLoginMsgDp(response.errMsg);
            } else if (response.errCode == '0020') {
              this.setLoginMsgDp(response.errMsg);
            } else if (response.errCode == '0030') {
              this.setLoginMsgDp(response.errMsg);
            } else if (response.errCode == '0040') {
              this.setLoginMsgDp(response.errMsg);
            } else if (response.errCode == '0050') {
              this.setLoginMsgDp(response.errMsg);
            } else if (response.errCode == '0060') {
              this.setLoginMsgDp(response.errMsg);
            }
          }
        }
      }
    } catch (e) {
      this.setLoginMsgDp(
        '처리중 문제가 발생하였습니다. <br /> 관리자에게 문의 바랍니다.'
      );
    }
  }

  async valueObjChange(model, value) {
    this.setValueObj({ ...this.valueObj, [model]: value });
  }
}

export default LoginController;
